/** `?store=<domain>` picks the store; `?store=` (blank) forgets a remembered one. */
export const STORE_OVERRIDE_PARAM = 'store';
/** Remembers the picked store across navigations. Readable by the client on purpose. */
export const STORE_OVERRIDE_COOKIE = 'ac_store_override';
